const topicsData = [
  { tag: '某顶流塌房', count: '128万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '综艺翻车现场', count: '96万讨论', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '品牌代言风波', count: '83万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { tag: '影视圈潜规则', count: '71万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '网红人设崩塌', count: '65万讨论', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '选秀黑幕曝光', count: '58万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { tag: '直播带货翻车', count: '47万讨论', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '艺人合约纠纷', count: '39万讨论', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '剧组内部爆料', count: '32万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热门话题</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">当前最受关注的热议话题，点击探索更多精彩内幕</p>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border font-medium text-sm md:text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap ${item.color}`}
            >
              <span className="text-xs opacity-60">#</span>
              {item.tag}
              <span className="text-xs opacity-70 ml-1">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}